module.exports = ":host footer {\n  padding-bottom: 8vh; }\n"